import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  loading: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loader/index.js